import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PermissionGuard } from '@/shared/ui/permission-guard'

export const Route = createFileRoute('/_auth/canteen/menu-settings/catalog-menu')({
  staticData: {
    meta: {
      title: 'Каталог меню',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.MENU_CATALOG}>
      <Outlet />
    </PermissionGuard>
  )
}
